import { waveCells } from './signature';
import type { HeroDefinition, WaveDir } from '../types';

/** Splash — clear two lines on the edge the wave travels toward. */
export const otto: HeroDefinition = {
  id: 'otto',
  name: 'Otto',
  species: 'otter',
  classId: 'tidecaller',
  powerName: 'Splash',
  color: 'moonstone',
  description: 'Clears two lines on the edge you aim.',
  target: 'wave',
  paw: 'cc_hero_otto_paw@1x.png',
  apply(state, _player, _target, aim) {
    const dir: WaveDir = aim?.dir ?? 'down';
    return { clear: waveCells(state, dir), convert: [] };
  },
};
